import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData, getDropdownIdsFromSelectArray } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";

export const getDropdowns = async () => {
    try {
        const resp = await Promise.all([
            dropdownMapping(
                endpoint.businessArea.getAllActive,
                "businessAreaDispValue",
                "id",
                "regionId"
            ),
            dropdownMapping(
                endpoint.getRole.roleWithApprovalPermissions,
                "roleName",
                "id",
            ),
            dropdownMapping(
                endpoint.academic_year.getAllActive,
                "academicYearDisplayValue",
                "id",
            ),

        ]);
        return {
            allActiveBu: resp[0],
            allActiveRoles: resp[1],
            allActiveYear: resp[2],
        };
    } catch (err) {
        console.error(err);
    }
}

export const hardcodeDropdown = {
    vendorTypes: [
        {
            label: "Invigilator",
            value: "INVIGILATOR"
        },
        {
            label: "Admission Advisor",
            value: "ADMISSION_ADVISOR"
        },
    ],
    events: [
        {
            label: "UPDATE_APPROVER_CONFIG_BU",
            value: "UPDATE_APPROVER_CONFIG_BU"
        },
        {
            label: "UPDATE_APPROVER_CONFIG_YEAR",
            value: "UPDATE_APPROVER_CONFIG_YEAR"
        },
        {
            label: "UPDATE_APPROVER_CONFIG_LEVEL_1",
            value: "UPDATE_APPROVER_CONFIG_LEVEL_1"
        },
        {
            label: "UPDATE_APPROVER_CONFIG_LEVEL_2",
            value: "UPDATE_APPROVER_CONFIG_LEVEL_2"
        },
        {
            label: "UPDATE_APPROVER_CONFIG_LEVEL_3",
            value: "UPDATE_APPROVER_CONFIG_LEVEL_3"
        },
        {
            label: "UPDATE_APPROVER_CONFIG_LEVEL_4",
            value: "UPDATE_APPROVER_CONFIG_LEVEL_4"
        },
        {
            label: "CREATE_APPROVER_CONFIG",
            value: "CREATE_APPROVER_CONFIG"
        }
    ]
};

export const getConfigs = async (filterReqObj, offset = 0, pageSize = 100) => {
    return await fetchAllPostPromisedData(`${endpoint.vendorConfig.search}?page=${offset}&size=${pageSize}`, filterReqObj);
}

export const createConfig = async (form) => {
    let reqObj = createVendorConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint.vendorConfig.create, reqObj);
}

export const updateConfig = async (form) => {
    let reqObj = createVendorConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint.vendorConfig.update, reqObj);
}

const createVendorConfigReqObj = (form) => {
    const {
        id,
        isNew,
        vendorType,
        businessArea = [],
        year = [],
        rolesByLevel = {}
    } = form;

    const approverLevelRoleMappingDTOList = Object.entries(rolesByLevel)
        .flatMap(([level, roles]) =>
            (roles || []).map(role => ({
                roleId: role.value,
                roleDispVal: role.label,
                approverLevel: Number(level)
            }))
        );

    return {
        ...(!isNew && { id }),
        vendorType: vendorType?.value,
        businessAreaIds: getDropdownIdsFromSelectArray(businessArea),
        yearIds: getDropdownIdsFromSelectArray(year),
        approverLevelRoleMappingDTOList
    };
};


const EMPTY_ROLES_BY_LEVEL = {
    1: [],
    2: [],
    3: [],
    4: []
};

export const getFormattedVendorConfig = (config, dropdownData) => {
    const {
        id,
        vendorType,
        businessAreaIds = [],
        yearIds = [],
        roleLevelApprovals = {},
        updatedOn,
        updatedBy
    } = config;

    const { allActiveBu, allActiveYear, allActiveRoles } = dropdownData;

    const mapRoles = (level) =>
        (roleLevelApprovals[`LEVEL_${level}`] || [])
            .map(r =>
                allActiveRoles.find(role =>
                    Number(role.value) === Number(r.roleId)
                )
            )
            .filter(Boolean);

    return {
        id,
        vendorType: hardcodeDropdown.vendorTypes.find(
            v => v.value === vendorType
        ),

        businessArea: businessAreaIds.map(id =>
            allActiveBu?.find(bu => Number(bu.value) === Number(id))
        ),

        year: yearIds.map(id =>
            allActiveYear.find(y => Number(y.value) === Number(id))
        ),

        // 🔑 SINGLE SOURCE OF TRUTH
        rolesByLevel: {
            ...EMPTY_ROLES_BY_LEVEL,
            1: mapRoles(1),
            2: mapRoles(2),
            3: mapRoles(3),
            4: mapRoles(4)
        },

        updatedOn,
        updatedBy
    };
};


export const getFilterReqObj = (filters = {}, allActiveBu = []) => {
    const {
        businessAreaIds = [],
        yearIds = [],
        vendorTypes = []
    } = filters;

    return {
        businessAreaIds: getDropdownIdsFromSelectArray(
            businessAreaIds.length ? businessAreaIds : allActiveBu
        ),
        yearIds: getDropdownIdsFromSelectArray(yearIds),
        vendorTypes: vendorTypes?.length
            ? vendorTypes.map(v => v.value)
            : []
    };
};
